import { EnrollmentStatus, QualifyingLifeEventType } from '@zorro/clients';

export function hasIncompleteQleElection(
  status?: EnrollmentStatus | null,
  qleType?: QualifyingLifeEventType | null
): boolean {
  if (!status) return false;

  const STATUSES = new Set<EnrollmentStatus>([
    EnrollmentStatus.PENDING_ELECTION_WINDOW,
    EnrollmentStatus.ELECTION_ACTIVE_HAS_NOT_STARTED,
    EnrollmentStatus.ELECTION_ACTIVE_STARTED,
    EnrollmentStatus.ELECTION_ACTIVE,
  ]);

  return Boolean(
    qleType &&
    qleType !== QualifyingLifeEventType.NEW_DEPENDENT &&
    STATUSES.has(status)
  );
}
